import { css } from '@emotion/core';
import { mq } from '../../cssInJs';
export default {
  button: css(mq({
    position: 'absolute',
    top: '16%',
    left: '1rem',
    lineHeight: '1.6rem',
    color: '#fff',
    fontSize: ['12px', null, '15px']
  })),
}